import { Substitute } from "@finway-group/shared/lib/models/user/Substitute"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { useAuth } from "~Shared/hooks/auth.hooks"
import { UserService } from "../services"
import { CacheEnum } from "./consts"

export const useUpsertSubstitutes = ({ companyId, onSuccess, onError }: { companyId: string; onSuccess?: () => void; onError?: (error: Error) => void }) => {
    const queryClient = useQueryClient()
    const { isAuthenticated, userId } = useAuth()
    const { t } = useTranslation()
    return useMutation({
        mutationFn: (substitutes: Array<Substitute>) => {
            if (!isAuthenticated || !userId) {
                return Promise.reject(new Error(t("error:auth.not_authenticated")))
            }
            return UserService.patchCompanyProfile({ userId, companyId, payload: { substitutes } })
        },
        onSuccess: async () => {
            onSuccess?.()
            await queryClient.invalidateQueries({ queryKey: [CacheEnum.EMPLOYEE, userId] })
        },
        onError: (error) => {
            onError?.(error as Error)
        },
    })
}
